//#region Login User
export const VALIDATE_LOGIN_USER_REQUEST = 'VALIDATE_LOGIN_USER_REQUEST';
export const VALIDATE_LOGIN_USER_SUCCESS = 'VALIDATE_LOGIN_USER_SUCCESS';
export const VALIDATE_LOGIN_USER_FAILED = 'VALIDATE_LOGIN_USER_FAILED';
//#endregion

//#region Forgot Passwrord
export const FORGOT_PASSWORD_REQUEST = 'FORGOT_PASSWORD_REQUEST';
export const FORGOT_PASSWORD_SUCCESS = 'FORGOT_PASSWORD_SUCCESS';
export const FORGOT_PASSWORD_FAILED = 'FORGOT_PASSWORD_FAILED';
//#endregion

//#region New Passwrord
export const NEW_PASSWORD_REQUEST = 'NEW_PASSWORD_REQUEST';
export const NEW_PASSWORD_SUCCESS = 'NEW_PASSWORD_SUCCESS';
export const NEW_PASSWORD_FAILED = 'NEW_PASSWORD_FAILED';
//#endregion

//#region Read Notification
export const READ_NOTIFICATION_REQUEST = 'READ_NOTIFICATION_REQUEST';
export const READ_NOTIFICATION_SUCCESS = 'READ_NOTIFICATION_SUCCESS';
export const READ_NOTIFICATION_FAILED = 'READ_NOTIFICATION_FAILED';
//#endregion

//#region Proofreader Dashboard
export const GET_PROOFREADER_DASHBOARD_REQUEST = 'GET_PROOFREADER_DASHBOARD_REQUEST';
export const GET_PROOFREADER_DASHBOARD_SUCCESS = 'GET_PROOFREADER_DASHBOARD_SUCCESS';
export const GET_PROOFREADER_DASHBOARD_FAILED = 'GET_PROOFREADER_DASHBOARD_FAILED';
export const RESET_PROOFREADER_DASHBOARD = 'RESET_PROOFREADER_DASHBOARD';
//#endregion

//#region Files Like
export const FILE_REJECT_REQUEST = 'FILE_REJECT_REQUEST';
export const FILE_REJECT_SUCCESS = 'FILE_REJECT_SUCCESS';
export const FILE_REJECT_FAILED = 'FILE_REJECT_FAILED';
//#endregion

//#region proofreader Files Filter
export const GET_PROOFREADER_FILES_FILTER_LIST_REQUEST = 'GET_PROOFREADER_FILES_FILTER_LIST_REQUEST';
export const GET_PROOFREADER_FILES_FILTER_LIST_SUCCESS = 'GET_PROOFREADER_FILES_FILTER_LIST_SUCCESS';
export const GET_PROOFREADER_FILES_FILTER_LIST_FAILED = 'GET_PROOFREADER_FILES_FILTER_LIST_FAILED';
//#endregion

//#region CGA Client List
export const GET_CGA_CLIENT_LIST_REQUEST = 'GET_CGA_CLIENT_LIST_REQUEST';
export const GET_CGA_CLIENT_LIST_SUCCESS = 'GET_CGA_CLIENT_LIST_SUCCESS';
export const GET_CGA_CLIENT_LIST_FAILED = 'GET_CGA_CLIENT_LIST_FAILED';
//#endregion

//#region proofreader All Files
export const GET_PROOFREADER_ALL_FILES_LIST_REQUEST = 'GET_PROOFREADER_ALL_FILES_LIST_REQUEST';
export const GET_PROOFREADER_ALL_FILES_LIST_SUCCESS = 'GET_PROOFREADER_ALL_FILES_LIST_SUCCESS';
export const GET_PROOFREADER_ALL_FILES_LIST_FAILED = 'GET_PROOFREADER_ALL_FILES_LIST_FAILED';
export const RESET_PROOFREADER_ALL_FILES_LIST = 'RESET_PROOFREADER_ALL_FILES_LIST';
//#endregion

//#region proofreader My Files
export const GET_PROOFREADER_MY_FILES_LIST_REQUEST = 'GET_PROOFREADER_MY_FILES_LIST_REQUEST';
export const GET_PROOFREADER_MY_FILES_LIST_SUCCESS = 'GET_PROOFREADER_MY_FILES_LIST_SUCCESS';
export const GET_PROOFREADER_MY_FILES_LIST_FAILED = 'GET_PROOFREADER_MY_FILES_LIST_FAILED';
//#endregion

//#region Vendors
export const GET_VENDORS_LIST_REQUEST = 'GET_VENDORS_LIST_REQUEST';
export const GET_VENDORS_LIST_SUCCESS = 'GET_VENDORS_LIST_SUCCESS';
export const GET_VENDORS_LIST_FAILED = 'GET_VENDORS_LIST_FAILED';
//#endregion

//#region Vendors Filter
export const GET_VENDORS_FILTER_LIST_REQUEST = 'GET_VENDORS_FILTER_LIST_REQUEST';
export const GET_VENDORS_FILTER_LIST_SUCCESS = 'GET_VENDORS_FILTER_LIST_SUCCESS';
export const GET_VENDORS_FILTER_LIST_FAILED = 'GET_VENDORS_FILTER_LIST_FAILED';
//#endregion

//#region Metrics
export const GET_MY_METRICS_LIST_REQUEST = 'GET_MY_METRICS_LIST_REQUEST';
export const GET_MY_METRICS_LIST_SUCCESS = 'GET_MY_METRICS_LIST_SUCCESS';
export const GET_MY_METRICS_LIST_FAILED = 'GET_MY_METRICS_LIST_FAILED';
export const RESET_MY_METRICS_LIST_DATA = 'RESET_MY_METRICS_LIST_DATA';
//#endregion

//#region Prfile
export const GET_PROFILE_REQUEST = 'GET_PROFILE_REQUEST';
export const GET_PROFILE_SUCCESS = 'GET_PROFILE_SUCCESS';
export const GET_PROFILE_FAILED = 'GET_PROFILE_FAILED';
//#endregion

//#region Prfile Upload
export const EDIT_PROFILE_REQUEST = 'EDIT_PROFILE_REQUEST';
export const EDIT_PROFILE_SUCCESS = 'EDIT_PROFILE_SUCCESS';
export const EDIT_PROFILE_FAILED = 'EDIT_PROFILE_FAILED';
//#endregion

//#region State
export const EDIT_STATE_REQUEST = 'EDIT_STATE_REQUEST';
export const EDIT_STATE_SUCCESS = 'EDIT_STATE_SUCCESS';
export const EDIT_STATE_FAILED = 'EDIT_STATE_FAILED';
//#endregion

//#region Password
export const CHANGE_PASSSWORD_REQUEST = 'CHANGE_PASSSWORD_REQUEST';
export const CHANGE_PASSSWORD_SUCCESS = 'CHANGE_PASSSWORD_SUCCESS';
export const CHANGE_PASSSWORD_FAILED = 'CHANGE_PASSSWORD_FAILED';
//#endregion

//#region Editor Document
export const EDITOR_REQUEST = 'EDITOR_REQUEST';
export const EDITOR_SUCCESS = 'EDITOR_SUCCESS';
export const EDITOR_FAILED = 'EDITOR_FAILED';
export const RESET_EDITOR_DATA = 'RESET_EDITOR_DATA';
//#endregion

//#region save transcript paragraph file
export const VENDOR_SAVE_TRANSCRIPT_PARAGRAPH_FILE_REQUEST = 'VENDOR_SAVE_TRANSCRIPT_PARAGRAPH_FILE_REQUEST';
export const VENDOR_SAVE_TRANSCRIPT_PARAGRAPH_FILE_SUCCESS = 'VENDOR_SAVE_TRANSCRIPT_PARAGRAPH_FILE_SUCCESS';
export const VENDOR_SAVE_TRANSCRIPT_PARAGRAPH_FILE_FAILED = 'VENDOR_SAVE_TRANSCRIPT_PARAGRAPH_FILE_FAILED';
//#endregion

//#region Vendor Next Transcript
export const VENDOR_NEXT_TRANSCRIPT_REQUEST = 'VENDOR_NEXT_TRANSCRIPT_REQUEST';
export const VENDOR_NEXT_TRANSCRIPT_SUCCESS = 'VENDOR_NEXT_TRANSCRIPT_SUCCESS';
export const VENDOR_NEXT_TRANSCRIPT_FAILED = 'VENDOR_NEXT_TRANSCRIPT_FAILED';
export const RESET_VENDOR_NEXT_TRANSCRIPT = 'RESET_VENDOR_NEXT_TRANSCRIPT';
//#endregion

//#region Proofreader Unclaim
export const PROOFREADER_UNCLAIM_REQUEST = 'PROOFREADER_UNCLAIM_REQUEST';
export const PROOFREADER_UNCLAIM_SUCCESS = 'PROOFREADER_UNCLAIM_SUCCESS';
export const PROOFREADER_UNCLAIM_FAILED = 'PROOFREADER_UNCLAIM_FAILED';
//#endregion

//#region Editor Document
export const EDITOR_DOCUMENTS_REQUEST = 'EDITOR_DOCUMENTS_REQUEST';
export const EDITOR_DOCUMENTS_SUCCESS = 'EDITOR_DOCUMENTS_SUCCESS';
export const EDITOR_DOCUMENTS_FAILED = 'EDITOR_DOCUMENTS_FAILED';
export const RESET_EDITOR_DOCUMENTS_DATA = 'RESET_EDITOR_DOCUMENTS_DATA';
//#endregion

//#region Vendor proof-reader comment
export const VENDOR_PROOFREADER_COMMENT_REQUEST = 'VENDOR_PROOFREADER_COMMENT_REQUEST';
export const VENDOR_PROOFREADER_COMMENT_SUCCESS = 'VENDOR_PROOFREADER_COMMENT_SUCCESS';
export const VENDOR_PROOFREADER_COMMENT_FAILED = 'VENDOR_PROOFREADER_COMMENT_FAILED';
//#endregion

//#region Vendor resolve proof-reader
export const VENDOR_RESOLVE_PROOFREADER_REQUEST = 'VENDOR_RESOLVE_PROOFREADER_REQUEST';
export const VENDOR_RESOLVE_PROOFREADER_SUCCESS = 'VENDOR_RESOLVE_PROOFREADER_SUCCESS';
export const VENDOR_RESOLVE_PROOFREADER_FAILED = 'VENDOR_RESOLVE_PROOFREADER_FAILED';
//#endregion

//#region Vendor details
export const VENDOR_DETAILS_REQUEST = 'VENDOR_DETAILS_REQUEST';
export const VENDOR_DETAILS_SUCCESS = 'VENDOR_DETAILS_SUCCESS';
export const VENDOR_DETAILS_FAILED = 'VENDOR_DETAILS_FAILED';
//#endregion

//#region Vendor name list
export const VENDOR_NAME_LIST_REQUEST = 'VENDOR_NAME_LIST_REQUEST';
export const VENDOR_NAME_LIST_SUCCESS = 'VENDOR_NAME_LIST_SUCCESS';
export const VENDOR_NAME_LIST_FAILED = 'VENDOR_NAME_LIST_FAILED';
//#endregion

//#region Proofreader role submit
export const PROOFREADER_ROLE_EDITOR_SUBMIT_REQUEST = 'PROOFREADER_ROLE_EDITOR_SUBMIT_REQUEST';
export const PROOFREADER_ROLE_EDITOR_SUBMIT_SUCCESS = 'PROOFREADER_ROLE_EDITOR_SUBMIT_SUCCESS';
export const PROOFREADER_ROLE_EDITOR_SUBMIT_FAILED = 'PROOFREADER_ROLE_EDITOR_SUBMIT_FAILED';
//#endregion

//#region Vendor role submit
export const VENDOR_ROLE_EDITOR_SUBMIT_REQUEST = 'VENDOR_ROLE_EDITOR_SUBMIT_REQUEST';
export const VENDOR_ROLE_EDITOR_SUBMIT_SUCCESS = 'VENDOR_ROLE_EDITOR_SUBMIT_SUCCESS';
export const VENDOR_ROLE_EDITOR_SUBMIT_FAILED = 'VENDOR_ROLE_EDITOR_SUBMIT_FAILED';
//#endregion

//#region get all speakers
export const GET_ALL_SPEAKERS_REQUEST = 'GET_ALL_SPEAKERS_REQUEST';
export const GET_ALL_SPEAKERS_SUCCESS = 'GET_ALL_SPEAKERS_SUCCESS';
export const GET_ALL_SPEAKERS_FAILED = 'GET_ALL_SPEAKERS_FAILED';
export const RESET_ALL_SPEAKERS_DATA = 'RESET_ALL_SPEAKERS_DATA';
//#endregion

//#region update project speakers
export const UPDATE_SPEAKERS_REQUEST = 'UPDATE_SPEAKERS_REQUEST';
export const UPDATE_SPEAKERS_SUCCESS = 'UPDATE_SPEAKERS_SUCCESS';
export const UPDATE_SPEAKERS_FAILED = 'UPDATE_SPEAKERS_FAILED';
//#endregion

//#region delete project speakers
export const DELETE_SPEAKERS_REQUEST = 'DELETE_SPEAKERS_REQUEST';
export const DELETE_SPEAKERS_SUCCESS = 'DELETE_SPEAKERS_SUCCESS';
export const DELETE_SPEAKERS_FAILED = 'DELETE_SPEAKERS_FAILED';
//#endregion

//#region add project speakers
export const ADD_SPEAKERS_REQUEST = 'ADD_SPEAKERS_REQUEST';
export const ADD_SPEAKERS_SUCCESS = 'ADD_SPEAKERS_SUCCESS';
export const ADD_SPEAKERS_FAILED = 'ADD_SPEAKERS_FAILED';
//#endregion

//#region remove unused project speakers
export const REMOVE_UNUSED_SPEAKERS_REQUEST = 'REMOVE_UNUSED_SPEAKERS_REQUEST';
export const REMOVE_UNUSED_SPEAKERS_SUCCESS = 'REMOVE_UNUSED_SPEAKERS_SUCCESS';
export const REMOVE_UNUSED_SPEAKERS_FAILED = 'REMOVE_UNUSED_SPEAKERS_FAILED';
//#endregion

//#region complete paragraph
export const TRANSCRIPT_COMPLETE_PARAGRAPH_REQUEST = 'TRANSCRIPT_COMPLETE_PARAGRAPH_REQUEST';
export const TRANSCRIPT_COMPLETE_PARAGRAPH_SUCCESS = 'TRANSCRIPT_COMPLETE_PARAGRAPH_SUCCESS';
export const TRANSCRIPT_COMPLETE_PARAGRAPH_FAILED = 'TRANSCRIPT_COMPLETE_PARAGRAPH_FAILED';
//#endregion

//#region CheckForceUnclaim
export const CHECK_FORCE_UNCLAIM_REQUEST = 'CHECK_FORCE_UNCLAIM_REQUEST';
export const CHECK_FORCE_UNCLAIM_SUCCESS = 'CHECK_FORCE_UNCLAIM_SUCCESS';
export const CHECK_FORCE_UNCLAIM_FAILED = 'CHECK_FORCE_UNCLAIM_FAILED';
export const CHECK_FORCE_UNCLAIM_RESET = 'CHECK_FORCE_UNCLAIM_FAILED';
//#endregion

export const ADD_NEW_SPEAKER_REQUEST = 'ADD_NEW_SPEAKER_REQUEST';
export const ADD_NEW_SPEAKER_SUCCESS = 'ADD_NEW_SPEAKER_SUCCESS';
export const ADD_NEW_SPEAKER_FAILED = 'ADD_NEW_SPEAKER_FAILED';
export const ADD_NEW_SPEAKER = 'ADD_NEW_SPEAKER';

//#region Save Slate Data
export const SAVE_SLATE_DATA_REQUEST = 'SAVE_SLATE_DATA_REQUEST';
export const SAVE_SLATE_DATA_SUCCESS = 'SAVE_SLATE_DATA_SUCCESS';
export const SAVE_SLATE_DATA_FAILURE = 'SAVE_SLATE_DATA_FAILURE';
export const UPDATE_LAST_SAVED_TIME = 'UPDATE_LAST_SAVED_TIME';

// /#region get slate data
export const GET_SLATE_DATA_REQUEST = 'GET_SLATE_DATA_REQUEST';
export const GET_SLATE_DATA_SUCCESS = 'GET_SLATE_DATA_SUCCESS';
export const GET_SLATE_DATA_FAILED = 'GET_SLATE_DATA_FAILED';
export const ADD_SPEAKER_LABEL = 'ADD_SPEAKER_LABEL';
export const UPDATE_SLATE_DATA = 'UPDATE_SLATE_DATA';
export const UPDATE_FLAG_SLATE_DATA = 'UPDATE_FLAG_SLATE_DATA';
export const UPDATE_COMPLETED_PERCENTAGE = 'UPDATE_COMPLETED_PERCENTAGE';
export const UPDATE_COMPLETED_BY_INDEX = 'UPDATE_COMPLETED_BY_INDEX';
export const UPDATE_SLATE_DATA_LOADING_STATE = 'UPDATE_SLATE_DATA_LOADING_STATE';
export const UPDATE_SLATE_IS_DIRTY = 'UPDATE_SLATE_IS_DIRTY';
export const UPDATE_SLATE_SELECTED_NODE = 'UPDATE_SLATE_SELECTED_NODE';
export const UPDATE_SLATE_NOT_COMPLETED_NODES = 'UPDATE_SLATE_NOT_COMPLETED_NODES';
export const UPDATE_SLATE_VENDOR_NOTES = 'UPDATE_SLATE_VENDOR_NOTES';
export const UPDATE_SLATE_IS_CLAIM = 'UPDATE_SLATE_IS_CLAIM';
export const UPDATE_SCROLL_TO_INDEX_VALUE = 'UPDATE_SCROLL_TO_INDEX_VALUE';
//#endregion

export const RESET_COMPLETED_PERCENTAGE = 'RESET_COMPLETED_PERCENTAGE'; // New action type
export const RESET_EDITOR_STATE = 'RESET_EDITOR_STATE';

//#region Settings
export const SET_REWIND_TIME = 'SET_REWIND_TIME';
export const SET_FONT_SIZE = 'SET_FONT_SIZE';
export const SET_SYNC_WITH_AUDIO = 'SET_SYNC_WITH_AUDIO';
export const SET_OPEN_SPEAKER_MODAL = 'SET_OPEN_SPEAKER_MODAL';
export const RESET_SETTINGS = 'RESET_SETTINGS';
export const SET_AUTO_SCROLL_WITH_SYNC = 'SET_AUTO_SCROLL_WITH_SYNC';
export const SET_AUDIO_START_TIME = 'SET_AUDIO_START_TIME';
export const UPDATE_LAST_WORKED_PARAGRAPH = 'UPDATE_LAST_WORKED_PARAGRAPH';

//#region Restore
export const RESTORE_REQUEST = 'RESTORE_REQUEST';
export const RESTORE_SUCCESS = 'RESTORE_SUCCESS';
export const RESTORE_FAILURE = 'RESTORE_FAILURE';
//#endregion

//#region Find and replace
export const UPDATE_FIND_AND_REPLACE_STATE = 'UPDATE_FIND_AND_REPLACE_STATE';
//#endregion

//#region Get Legal Template Form Field Details
export const GET_LEGAL_TEMPLATE_FORM_FIELD_DETAILS_REQUEST = 'GET_LEGAL_TEMPLATE_FORM_FIELD_DETAILS_REQUEST';
export const GET_LEGAL_TEMPLATE_FORM_FIELD_DETAILS_SUCCESS = 'GET_LEGAL_TEMPLATE_FORM_FIELD_DETAILS_SUCCESS';
export const GET_LEGAL_TEMPLATE_FORM_FIELD_DETAILS_FAILED = 'GET_LEGAL_TEMPLATE_FORM_FIELD_DETAILS_FAILED';
//#endregion

//#region Save or Update Legal Template Form Details
export const SAVE_LEGAL_TEMPLATE_FORM_FIELD_DETAILS_REQUEST = 'SAVE_LEGAL_TEMPLATE_FORM_FIELD_DETAILS_REQUEST';
export const SAVE_LEGAL_TEMPLATE_FORM_FIELD_DETAILS_SUCCESS = 'SAVE_LEGAL_TEMPLATE_FORM_FIELD_DETAILS_SUCCESS';
export const SAVE_LEGAL_TEMPLATE_FORM_FIELD_DETAILS_FAILED = 'SAVE_LEGAL_TEMPLATE_FORM_FIELD_DETAILS_FAILED';
//#endregion

//#region Download Legal Document
export const DOWNLOAD_LEGAL_DOCUMENT_REQUEST = 'DOWNLOAD_LEGAL_DOCUMENT_REQUEST';
export const DOWNLOAD_LEGAL_DOCUMENT_SUCCESS = 'DOWNLOAD_LEGAL_DOCUMENT_SUCCESS';
export const DOWNLOAD_LEGAL_DOCUMENT_FAILED = 'DOWNLOAD_LEGAL_DOCUMENT_FAILED';
//#endregion

//#region Upload Legal Document
export const UPLOAD_LEGAL_DOCUMENT_REQUEST = 'UPLOAD_LEGAL_DOCUMENT_REQUEST';
export const UPLOAD_LEGAL_DOCUMENT_SUCCESS = 'UPLOAD_LEGAL_DOCUMENT_SUCCESS';
export const UPLOAD_LEGAL_DOCUMENT_FAILED = 'UPLOAD_LEGAL_DOCUMENT_FAILED';
//#endregion

//#region Proofreader CGA Files
export const GET_CGA_FILES_LIST_REQUEST = 'GET_CGA_FILES_LIST_REQUEST';
export const GET_CGA_FILES_LIST_SUCCESS = 'GET_CGA_FILES_LIST_SUCCESS';
export const GET_CGA_FILES_LIST_FAILED = 'GET_CGA_FILES_LIST_FAILED';
//#endregion

//#region Merge CGA File Collection Download
export const MERGE_CGA_FILE_COLLECTION_DOWNLOAD_REQUEST = 'MERGE_CGA_FILE_COLLECTION_DOWNLOAD_REQUEST';
export const MERGE_CGA_FILE_COLLECTION_DOWNLOAD_SUCCESS = 'MERGE_CGA_FILE_COLLECTION_DOWNLOAD_SUCCESS';
export const MERGE_CGA_FILE_COLLECTION_DOWNLOAD_FAILED = 'MERGE_CGA_FILE_COLLECTION_DOWNLOAD_FAILED';
//#endregion

//#region Save File Merge Status CGA
export const SAVE_FILE_MERGE_STATUS_CGA_REQUEST = 'SAVE_FILE_MERGE_STATUS_CGA_REQUEST';
export const SAVE_FILE_MERGE_STATUS_CGA_SUCCESS = 'SAVE_FILE_MERGE_STATUS_CGA_SUCCESS';
export const SAVE_FILE_MERGE_STATUS_CGA_FAILED = 'SAVE_FILE_MERGE_STATUS_CGA_FAILED';
//#endregion

//#region Update CGA File States
export const UPDATE_CGA_FILE_STATES = 'UPDATE_CGA_FILE_STATES';
export const RESET_CGA_FILE_STATES = 'RESET_CGA_FILE_STATES';
//#endregion

//#region Glossary
export const GET_GLOSSARY_PREVIEW_REQUEST = 'GET_GLOSSARY_PREVIEW_REQUEST';
export const GET_GLOSSARY_PREVIEW_SUCCESS = 'GET_GLOSSARY_PREVIEW_SUCCESS';
export const GET_GLOSSARY_PREVIEW_FAILED = 'GET_GLOSSARY_PREVIEW_FAILED';
export const GET_GLOSSARY_LIST_REQUEST = 'GET_GLOSSARY_LIST_REQUEST';
export const GET_GLOSSARY_LIST_SUCCESS = 'GET_GLOSSARY_LIST_SUCCESS';
export const GET_GLOSSARY_LIST_FAILED = 'GET_GLOSSARY_LIST_FAILED';
export const OPEN_GLOSSARY_MODAL = 'OPEN_GLOSSARY_MODAL';
export const CLOSE_GLOSSARY_MODAL = 'CLOSE_GLOSSARY_MODAL';
export const SET_GLOSSARY_SEARCH = 'SET_GLOSSARY_SEARCH';
export const CYCLE_GLOSSARY_SORT = 'CYCLE_GLOSSARY_SORT';
export const NEXT_GLOSSARY_PAGE = 'NEXT_GLOSSARY_PAGE';
export const RETRY_GLOSSARY_LIST = 'RETRY_GLOSSARY_LIST';
export const RESET_GLOSSARY_STATE = 'RESET_GLOSSARY_STATE';
//#endregion
